<template>
  <v-dialog v-model="mostrar" max-width="500" persistent>
    <v-card>
      <v-toolbar color="primary" dark dense flat><h3>Foto de usuario</h3></v-toolbar>
      <v-container>
        <v-row>
          <v-col cols="12">
           
            <v-file-input label="Click para subir foto de usuario" dense outlined :loading="loading" :disabled="loading" :error-messages="error" persistent-hint @change="subir()" prepend-icon="mdi-camera" v-model="foto"></v-file-input>

          </v-col>
        </v-row>
       
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="primary"
          small
          @click="foto()"
          >Subir</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cargarFoto } from "./usuarios.service";

export default {
  props: ["mostrar", "idUsuario","fotoUsuario"],
  computed: {
  
  },
  data() {
    return {
      loading: false,
      progreso: 0,
      foto: null,
      error: null,
    };
  },
  methods: {
   
    async subir() {
      if (this.foto) {
        this.error = null;
        try {
          this.loading = true;
          if(this.foto.type !== "image/jpeg") this.error="No se seleccionó una imagen compatible"
          //  throw new Error("No se seleccionó una imagen compatible");
          const fotoImg = new FormData();
          fotoImg.append("foto", this.foto);
          const uploadHandler = {
            onUploadProgress: (progressEvent) =>
              (this.progreso =
                (progressEvent.loaded * 100) / progressEvent.total),
            };
          const serverResponse = await cargarFoto(this.idUsuario, fotoImg, uploadHandler);
          if(!serverResponse.ok) this.error = serverResponse.mensaje;
          this.loading = false;
          this.$emit('fotoAgregada', serverResponse.usuario.foto)
          this.$emit('cancelar')
          
        } catch (error) {
          this.loading = false;
          this.$notificarError(error);
        }
     }
    }
  },
};
</script>
